import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center mb-4">
              <span className="text-2xl font-bold text-blue-600" style={{ fontFamily: "Pacifico, serif" }}>
                財恩工房
              </span>
            </Link>
            <p className="text-gray-600 mb-4">
              学習支援サービス「ボラタス」の開発・運営
            </p>
            <p className="text-gray-600 mb-4">
              居場所とボランティアをやさしくつなぎ、良いことが続く環境をつくります。
            </p>
            <div className="text-sm text-gray-500 mb-4">
              <p>財恩工房（個人事業）</p>
            </div>
            {/* Social Media Links */}
            <div className="flex items-center gap-4 mt-6">
              <a 
                href="https://note.com/b0ratasu_bene" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-white border border-gray-300 rounded-lg hover:border-blue-600 transition-colors">
                  <img 
                    src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/7ac9fdb85cc93e95c35b621dceda84e0.png" 
                    alt="note" 
                    className="w-5 h-5 object-contain"
                  />
                </div>
                <span className="text-sm font-medium">note</span>
              </a>
            </div>
          </div>

          {/* Navigation Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">サイトマップ</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/story" className="text-gray-600 hover:text-blue-600 transition-colors">
                  ストーリー
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-gray-600 hover:text-blue-600 transition-colors">
                  しくみ
                </Link>
              </li>
              <li>
                <Link to="/safety" className="text-gray-600 hover:text-blue-600 transition-colors">
                  安全・FAQ
                </Link>
              </li>
              <li>
                <Link to="/for-places" className="text-gray-600 hover:text-blue-600 transition-colors">
                  居場所の皆さまへ
                </Link>
              </li>
              <li>
                <Link to="/for-volunteers" className="text-gray-600 hover:text-blue-600 transition-colors">
                  ボランティアの皆さまへ
                </Link>
              </li>
              <li>
                <a 
                  href="https://kyo-colle.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                >
                  おすすめ教材
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-blue-600 transition-colors">
                  お問い合わせ
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">法的情報</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="text-gray-600 hover:text-blue-600 transition-colors">
                  プライバシーポリシー
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-blue-600 transition-colors">
                  利用規約
                </Link>
              </li>
              <li>
                <Link to="/commercial" className="text-gray-600 hover:text-blue-600 transition-colors">
                  特定商取引法に基づく表示
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-8 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500">
            © 2024 財恩工房. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-500 hover:text-blue-600 transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
